import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {CommandResult} from "../../common/helpers/CommandResult";
import {MarketingListCustomerStatus} from "../model/MarketingListCustomerStatus";

export const postMarketingListCustomerStatus = (listId: number, personId: number, marketingStatus: MarketingListCustomerStatus): Promise<CommandResult> => {
    return AxiosClientFactory
        .getInstance()
        .post(`/api/marketingLists/${listId}/customers/${personId}/statusupdates`, { marketingStatus })
        .then((result) => new CommandResult(result));
};